import { ChevronDown, ChevronRight } from "@procore/core-icons";
import { Button, Card, H3, spacing, Title } from "@procore/core-react";

import { type PropertyGroup as PropertyGroupType } from "../hooks/usePropertyFiltering";
import { PropertyTable } from "./PropertyTable";

interface PropertyGroupProps {
    group: PropertyGroupType;
    searchTerm: string;
    isExpanded: boolean;
    selectedCount: number;
    isFullySelected: boolean;
    isPartiallySelected: boolean;
    isPropertySelected: (groupName: string, propertyName: string, propertyValue: string) => boolean;
    onToggleExpansion: () => void;
    onToggleGroupSelection: () => void;
    onTogglePropertySelection: (groupName: string, propertyName: string, propertyValue: string) => void;
}

export function PropertyGroup({
    group,
    searchTerm,
    isExpanded,
    selectedCount,
    isFullySelected,
    isPartiallySelected,
    isPropertySelected,
    onToggleExpansion,
    onToggleGroupSelection,
    onTogglePropertySelection,
}: PropertyGroupProps) {
    const cardStyle = {
        paddingTop: isExpanded ? spacing.md : spacing.sm,
        paddingBottom: isExpanded ? spacing.lg : spacing.sm,
        paddingLeft: spacing.lg,
        paddingRight: spacing.lg,
    };

    const titleStyle = {
        paddingBottom: isExpanded ? spacing.md : 0,
    };

    return (
        <Card style={cardStyle}>
            <Title style={titleStyle}>
                <Title.Assets>
                    <Button
                        icon={isExpanded ? <ChevronDown /> : <ChevronRight />}
                        onClick={onToggleExpansion}
                        variant="tertiary"
                        size="sm"
                    />
                </Title.Assets>
                <Title.Text>
                    <H3>
                        {group.displayName}
                        {selectedCount > 0 && ` (${selectedCount})`}
                    </H3>
                </Title.Text>
            </Title>

            {isExpanded && (
                <PropertyTable
                    group={group}
                    searchTerm={searchTerm}
                    isFullySelected={isFullySelected}
                    isPartiallySelected={isPartiallySelected}
                    isPropertySelected={isPropertySelected}
                    onToggleGroupSelection={onToggleGroupSelection}
                    onTogglePropertySelection={onTogglePropertySelection}
                />
            )}
        </Card>
    );
}
